<div class="loading-overlay" *ngIf="isLoading">
  <app-spinner [isLoading]="isLoading" [large]="true"></app-spinner>
</div>
